import { render, staticRenderFns } from "./CxCategoryApiHeader.vue?vue&type=template&id=4b98f22e&scoped=true&"
import script from "./CxCategoryApiHeader.vue?vue&type=script&lang=js&"
export * from "./CxCategoryApiHeader.vue?vue&type=script&lang=js&"
import style0 from "./CxCategoryApiHeader.vue?vue&type=style&index=0&id=4b98f22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98f22e",
  null
  
)

export default component.exports